import React from 'react';
import { Container, Button } from 'react-bootstrap';
import './index.scss';

function ViewedSection(props) {
    return(
        <Container className="section-container">
            {
                props.data.map((item, index) => {
                    if (index % 2 === 0) {
                        return (
                            <div className="row mb-3" key={index}>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-5 col-auto img-section-container text-center">
                                    <img
                                        className="shadow img-fluid img-section"
                                        src={item.imageUrl}
                                        alt="event"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-5 col-auto caption-section-container ml-auto">
                                    <h3 className="text-center">{item.title}</h3>
                                    <p className="text-center">{item.description}</p>
                                    <div className="text-center">
                                        <Button className="shadow btn btn-primary w-100" href={item.link1}>Lihat lebih lanjut
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <div className="row mb-3" key={index}>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-5 col-auto img-section-container text-center">
                                    <img
                                        className="shadow img-fluid img-section img-odd"
                                        src={item.imageUrl}
                                        alt="event"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-5 col-auto caption-section-container">
                                    <h3 className="text-center">{item.title}</h3>
                                    <p className="text-center">{item.description}</p>
                                    <div className="text-center">
                                        <Button className="shadow btn btn-primary w-100" href={item.link1}>Paper Competition for SMA
                                        </Button>
                                        <Button className="shadow btn btn-primary w-100" href={item.link2}>Innovation Competition for Universitas
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                })
            }
        </Container>
    );
}

export default ViewedSection;
